import { useEffect, useState } from 'react';
import { failureToast } from '../../../../support/utils';
import { DashboardStats, getDashboardStats } from '../redux/DashboardCRUD';

type UseDashboardStats = {
  stats: DashboardStats | null;
  isPending: boolean;
};

/**
 * Loads the cached dashboard aggregate counts on mount. Because the underlying
 * fetch is cached (see `getDashboardStats`), re-mounting the dashboard within
 * the cache TTL resolves from memory instead of hitting the API/database.
 */
export const useDashboardStats = (): UseDashboardStats => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    let active = true;

    getDashboardStats()
      .then((result) => {
        if (active) {
          setStats(result);
          setIsPending(false);
        }
      })
      .catch((error) => {
        if (active) {
          failureToast(error);
          setIsPending(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return { stats, isPending };
};
